
import { Component, Prop,Mixins} from 'vue-property-decorator'
import Common from '@/mixins/common'
import { EventData } from '@/common-datatypes'
import StaffInboxOnReferenceObjects from "@/components/StaffInboxOnReferenceObjects.vue";
import ModalEventMessenger from "@/components/ModalStaffEventMessenger.vue"
import EventDetails from "@/components/EventDetails.vue"
import ICalEventDetails from "@/components/ICalEventDetails.vue"


@Component({
  components: {
    StaffInboxOnReferenceObjects,
    ModalEventMessenger,
    EventDetails,
    ICalEventDetails
  }
})

export default class ModalStaffEventDetails extends Mixins(Common) {
  @Prop({type: String, default: ''}) private message?: string
  @Prop({type: String, default: 'message.yes'}) private confirmText?: string
  @Prop({type: String, default: 'message.no'}) private cancelText?: string
  @Prop({type: String, default: ''}) private errorMessage?: string
  @Prop({type: Object, default: {}}) private theEventData?: EventData

  isLoading: boolean | string = false

  isActive = true

  defaultModalMessengerProps = {
    replyMessageId: '',
    replyAllMessageId: '',
    reviewMessageId: '',
    theMessageId: '',
    theEventData: this.theEventData,
    isShow: false
  }

  modalMessengerProps = {} as this["defaultModalMessengerProps"]


  createMessage(){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      theEventData: this.theEventData,
      isShow: true
    }
  }

  get referenceObjectIds(){
    return (this.theEventData?.extendedProps.docId) ? [this.theEventData?.extendedProps.docId] : []
  }

  get eventId(){
    return this.theEventData?.id || ''
  }

  get title(){
    return this.theEventData?.title || ''
  }

  async created(){
    //
  }

  mounted(){
    //
  }

  selectAction(type: string){
    this.$emit("selectAction",{
      type: type,
      eventId: this.eventId
    })
  }

  onConfirm(yes: boolean) {
    this.$emit("onConfirm", yes)
  }

  editMessage(messageId: string){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      theMessageId: messageId,
      theEventData: this.theEventData,
      isShow: true
    }
  }

  replyMessage(messageId: string){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      replyMessageId: messageId,
      theEventData: this.theEventData,
      isShow: true
    }
  }

  replyAllMessage(messageId: string){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      replyAllMessageId: messageId,
      theEventData: this.theEventData,
      isShow: true
    }
  }

  reviewMessage(messageId: string){
    this.modalMessengerProps = {
      ...this.defaultModalMessengerProps,
      reviewMessageId: messageId,
      theEventData: this.theEventData,
      isShow: true
    }
  }

  destroyed() {
    console.trace('destroyed');
  }
}
